import { render, staticRenderFns } from "./dailyWinloseAffTab.vue?vue&type=template&id=43dd328a&lang=pug"
import script from "./dailyWinloseAffTab.vue?vue&type=script&lang=js"
export * from "./dailyWinloseAffTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports